<script lang="ts" setup>
	const bars = ['h-[80%]', 'h-2/3', 'h-4/5', 'h-5/6', 'h-1/3', 'h-2/3', 'h-5/6', 'h-[75%]', 'h-[95%]']
</script>
<template>
	<div class="mt-10 flex h-[300px] items-end justify-evenly px-4">
		<charts-candle-skeleton
			v-for="itm in bars"
			:key="itm"
			width="w-3"
			:height="itm"
			:border="false"
			class="loader max-h-0 bg-purple-400"
		/>
	</div>
</template>

<style scoped>
	.loader {
		animation: loader 1s ease-in-out infinite alternate;
	}

	.loader:nth-child(1) {
		animation-delay: 0.2s;
	}
	.loader:nth-child(2) {
		animation-delay: 0.4s;
	}
	.loader:nth-child(3) {
		animation-delay: 0.6s;
	}
	.loader:nth-child(4) {
		animation-delay: 0.8s;
	}
	.loader:nth-child(5) {
		animation-delay: 1s;
	}
	.loader:nth-child(6) {
		animation-delay: 1.2s;
	}
	.loader:nth-child(7) {
		animation-delay: 1.4s;
	}

	@keyframes loader {
		from {
			max-height: 0;
		}

		to {
			max-height: 300px;
		}
	}
</style>
